<template>
    <section class="custom-text-editor">
        <!-- <link href="https://cdn.quilljs.com/1.2.6/quill.snow.css" rel="stylesheet" /> -->

        <!-- <div id="tinymce-demo"></div> -->
        <!-- <tinymce id="d1" v-model="value"></tinymce> -->
        <!-- <tinymce-editor :init="tinymce" v-model="value" /> -->
        <!-- <ckeditor :editor="editor" v-model="value" :config="editorConfig"></ckeditor> -->
        <!-- <summernote :model="value"></summernote> -->
        <quill-editor
            class="quill-editor"
            ref="quillEditor"
            :value="content"
            :options="quillOptions"
            @change="onEditorChange"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
        />
    </section>
</template>

<script>
import {mapGetters} from "vuex"
import debounce from "lodash/debounce"

// import Vue from 'vue'
// import tinymce from 'vue-tinymce-editor'
// Vue.component('tinymce', tinymce)

// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// import DocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document'
// import Editor from '@ckeditor/ckeditor5-build-balloon'

// import VueQuill from 'vue-quill'
// Vue.use(VueQuill)

import Quill from "quill"
import {quillEditor} from "vue-quill-editor"
// highlight.js style
// import 'highlight.js/styles/tomorrow.css'
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
// import "quill/dist/quill.bubble.css"

import "./quill-responsive-video"

var Block = Quill.import("blots/block")
Block.tagName = "DIV"
Quill.register(Block, true)

export default {
    name: "TextEditor",
    components: {
        // tinymce,
        quillEditor
    },
    props: {
        init: {
            type: Object,
            default() {
                return {}
            }
        },
        value: {
            type: String,
            default() {
                return ""
            }
        }
    },
    data() {
        return {
            content: "",

            /**
             * Quill
             * ------------------------------------------
             */
            quillOptions: {
                // theme: 'bubble',
                theme: "snow",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote", "code-block"],
                        // [{ 'header': 1 }, { 'header': 2 }],
                        // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        // [{ 'script': 'sub' }, { 'script': 'super' }],
                        // [{ 'indent': '-1' }, { 'indent': '+1' }],
                        // [{ 'direction': 'rtl' }],
                        [{size: ["small", false, "large", "huge"]}],
                        [{header: [1, 2, 3, 4, 5, 6, false]}],
                        [{font: []}],
                        [{color: []}, {background: []}],
                        [{align: []}],
                        // ['clean'],
                        ["link", "image", "video"]
                    ]
                    // syntax: {
                    //   highlight: text => hljs.highlightAuto(text).value
                    // }
                }
            }

            /**
             * CKEditor
             * ------------------------------------------
             */
            // editor: Editor,
            // editorConfig: {
            //   // The configuration of the editor.
            // }

            /**
             * TinyMce
             * ------------------------------------------
             *  - Issues with dropdown menu when used inside modal as menu mounts to <body>
             */
            // tinymce: {
            //   content_css: '/vendor/tinymce/skins/content/dark/content.min.css',
            //   skin_url: '/vendor/tinymce/skins/ui/oxide',
            //   // theme_url: '/vendor/tinymce/themes/silver/theme.min.js',
            //   // icons_url: '/vendor/tinymce/',
            //   mode: 'textareas',
            //   force_p_newlines: false,
            //   force_br_newlines: true,
            //   // forced_root_block: '',
            //   // min_height: 200
            //   // inline: true,
            //   target: '#tinymce-demo',
            //   plugins: [
            //     'paste', 'link', 'code', 'autoresize',
            //     // 'example'
            //   ],
            //   external_plugins: [
            //   ],
            //   toolbar: [
            //     'code align format'
            //     // 'code example'
            //   ]
            // }
        }
    },
    computed: {
        ...mapGetters({})
    },
    watch: {},
    mounted() {
        // console.warn('HELLO TEXT EDITOR...')
        this.content = this.value
    },
    created() {
    },
    activated() {
    },
    methods: {
        onEditorChange: debounce(function (value) {
            const html = value.html
            this.content = html
            this.$emit("input", html)

            // this.content = html.replace(new RegExp('<p><br></p>', 'ig'), '')
            // console.warn('HTML', html)
            // console.warn('HTML Content', $(html).find('p').css({ margin: 0 }))
        }, 250),
        onEditorBlur() {
        },
        onEditorFocus() {
        },
        onEditorReady() {
        }
    }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

.quill-editor {
    // max-height: 300px;
}
</style>

<style lang="scss">
.quill-editor {
    .ql-editor {
        min-height: 160px;
    }

    .ql-snow {
        &.ql-toolbar {
            border: 1px solid #dcdfe6;
            border-radius: 4px 4px 0 0;
        }

        &.ql-container {
            border: 1px solid #dcdfe6;
            border-radius: 0 0 4px 4px;
        }
    }
}
</style>
